import React from 'react';
import { DeviceType } from '../enum/EnumRepository';
import { useDeviceStore } from '../store/deviceStore';


interface MobileConvertWrapperProps {
  onlyMobileChildren: React.ReactNode;
  onlyNotMobileChildren: React.ReactNode;
}

const MobileConvertWrapper: React.FC<MobileConvertWrapperProps> = ({ onlyMobileChildren, onlyNotMobileChildren }) => {
  const { deviceType } = useDeviceStore();

  return (
    <>
      {deviceType === DeviceType.MOBILE ? onlyMobileChildren : onlyNotMobileChildren}
    </>
  );
}



export default MobileConvertWrapper;